import { motion } from "framer-motion";
import { Check } from "lucide-react";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9äöü]+/g, "-").replace(/(^-|-$)/g, "");

export const QuizStep = ({ item, value, onSelect }) => (
  <motion.div initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}>
    <h3 data-testid="funnel-question" className="font-display text-2xl sm:text-4xl font-medium tracking-[-0.02em]">{item.q}</h3>
    {item.multi && <p className="mt-2 font-mono text-xs uppercase tracking-[0.2em] text-[var(--mist)]">Mehrfachauswahl möglich</p>}
    <div className="mt-8 grid gap-3 sm:grid-cols-2">
      {item.options.map((opt, i) => {
        const active = item.multi ? value.includes(opt) : value === opt;
        return (
          <motion.button
            key={opt}
            data-testid={`funnel-option-${item.key}-${slug(opt)}`}
            onClick={() => onSelect(opt)}
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 * i, duration: 0.4 }}
            whileTap={{ scale: 0.98 }}
            className={`group flex items-center justify-between gap-4 rounded-2xl border px-5 py-4 text-left transition-[background-color,border-color,color] duration-300 ${
              active ? "border-[var(--lagoon)] bg-[rgba(60,230,200,0.12)] text-[var(--foam)]" : "border-white/10 hover:border-white/30 text-[var(--foam)]"
            }`}
          >
            <span className="text-base">{opt}</span>
            <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors ${active ? "border-[var(--lagoon)] bg-[var(--lagoon)] text-[#04171B]" : "border-white/25"}`}>
              {active && <Check className="h-3.5 w-3.5" />}
            </span>
          </motion.button>
        );
      })}
    </div>
  </motion.div>
);
